// extracted by mini-css-extract-plugin
module.exports = {"container":"image-item_container__2yuhW","container-loader":"image-item_container-loader__2oxW7","no-image":"image-item_no-image__eBe2G"};